import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

import { PageLayout, SciDomainProvider } from 'components';
import { env } from 'config';
import { ROUTE_PATH } from 'constants/routes';
import { HelpPage, NotFoundPage, OrderPage } from 'pages';
import { DeeplinkPage } from 'pages/Deeplink';

const DemoPage = lazy(() =>
  import('pages/Demo').then((m) => ({ default: m.DemoPage })),
);

export const AppRoutes: React.FC = () => (
  <SciDomainProvider>
    <Routes>
      {env.enableDemo && (
        <Route
          path="/demo"
          element={
            <Suspense fallback={null}>
              <DemoPage />
            </Suspense>
          }
        />
      )}
      <Route element={<PageLayout />}>
        <Route path={ROUTE_PATH.ORDER} element={<OrderPage />} />
        <Route path={ROUTE_PATH.DEEPLINK} element={<DeeplinkPage />} />
        <Route path={ROUTE_PATH.HELP} element={<HelpPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  </SciDomainProvider>
);
